export default __webpack_public_path__ + "images/521834eb212d545663bca20cccfb1528-food_and_drink_desktop.webp";